import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconTrendingDownComponent } from "./med-icon-trending-down.component";

@NgModule({
  declarations: [
    MedIconTrendingDownComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconTrendingDownComponent,
  ],
})
export class MedIconTrendingDownModule { }
